import React, { useState } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import ListItem from "@mui/material/ListItem";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import Popover from "@mui/material/Popover";
import { withSnackbar } from "notistack";

import ChkBox from "components/Custom/ChkBox";
import Btn from "components/Custom/Btn";
import PopoverBtn from "components/Custom/PopoverBtn";

import { LABELS } from "common/lables";
import { SHOP_TYPES } from "common/config";
import { COLORS } from "common/colors";

import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet/dist/leaflet.css";

import "./styles/index.css";
import "./styles/fleetmap.css";

const MapSearchFilter = (props: any) => {
  const {
    shopTypes,
    setShopTypes,
    fromLatLng,
    toLatLng,
    setFromLatLng,
    showCustomer,
    setShowCustomer,
    setShowLeadProfiles,
    showLeadProfiles,
    getScavengingDetails,
    shopDetails,
    setToLatLng,
  } = props;

  const [showShopTypes, setShowShopTypes] = useState<any>(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [fromAddress, setFromAddress] = React.useState("");
  const [toAddress, setToAddress] = React.useState("");

  const onSelectShopType = (checked, f) => {
    let shopList = shopTypes;
    if (shopTypes.indexOf(f) === -1) {
      shopList.push(f);
    } else {
      shopList = shopTypes.filter((s) => s !== f);
    }
    if (f === "All") {
      if (checked) {
        shopList = SHOP_TYPES;
      } else {
        shopList = [];
      }
    } else {
      if (shopList.length !== SHOP_TYPES.length) {
        shopList = shopList.filter((shop) => shop !== "All");
      }
    }
    const allChecked = SHOP_TYPES.slice(1).every((shop) =>
      shopList.includes(shop)
    );
    if (allChecked && !shopList.includes("All")) {
      shopList.push("All");
    }

    setShopTypes([...shopList]);
  };

  const getShoptypes = (e) => {
    setAnchorEl(e.currentTarget);
    setShowShopTypes(!showShopTypes);
  };

  const handlePopoverClose = () => {
    setShowShopTypes(false);
  };

  const onAddressFrom = (address) => {
    setFromAddress(address);
  };
  const onAddressFromSelect = (address) => {
    let self = this;
    setFromAddress(address);
    geocodeByAddress(address)
      .then((results) => {
        console.log("results: ", results);
        const loc = results[0].geometry.location;
        const lat = loc.lat();
        const lng = loc.lng();
        setFromLatLng({ lat, lng });
        console.log("lat lng ", fromLatLng);
      })
      .catch((error) => console.error("Error", error));
  };

  //For To
  const onAddressTo = (address) => {
    setToAddress(address);
  };

  const onAddressToSelect = (address) => {
    let self = this;
    setToAddress(address);
    geocodeByAddress(address)
      .then((results) => {
        console.log("results: ", results);
        const loc = results[0].geometry.location;
        const lat = loc.lat();
        const lng = loc.lng();
        setToLatLng({ lat, lng });
        console.log("lat lng ", toLatLng);
      })
      .catch((error) => console.error("Error", error));
  };

  return (
    <div
      className="searchHeader"
      style={{ boxShadow: "0px 0px  0.5px 0.5px gray" }}
    >
      <ListItem style={{ width: "200px" }} onClick={getShoptypes}>
        <PopoverBtn
          text={LABELS.SELECT_TYPE}
          align={"bottom"}
          type={"outlined"}
        >
          {SHOP_TYPES.map((item, index) => (
            <div className="flexRow">
              <ChkBox
                id={item}
                text={item}
                controlled={true}
                checked={shopTypes.indexOf(item) > -1}
                onChange={(e, f) => {
                  onSelectShopType(e, f);
                }}
              />
            </div>
          ))}
        </PopoverBtn>
      </ListItem>

      <div style={{ display: "flex" }}>
        <label style={{ padding: "15px" }}>{LABELS.FROM}</label>
        <PlacesAutocomplete
          value={fromAddress}
          searchOptions={{
            componentRestrictions: {
              country: "in",
            },
          }}
          onChange={onAddressFrom}
          onSelect={onAddressFromSelect}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => (
            <div className="googlePlace " style={{ paddingTop: "10px" }}>
              <input
                {...getInputProps({
                  placeholder: "Search Address",
                  className: "",
                  id: "gSearchPlace",
                })}
              />
              <div className="autocomplete-dropdown-container">
                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? "suggestion-item--active"
                    : "suggestion-item";
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? {
                        backgroundColor: "#fafafa",
                        padding: "5px 15px 5px 15px",
                        cursor: "pointer",
                      }
                    : {
                        backgroundColor: "#ffffff",
                        padding: "5px 15px 5px 15px",
                        cursor: "pointer",
                      };
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </div>
      <div style={{ display: "flex" }}>
        <label style={{ padding: "15px" }}>{LABELS.TO}</label>
        <PlacesAutocomplete
          value={toAddress}
          searchOptions={{
            componentRestrictions: {
              country: "in",
            },
          }}
          onChange={onAddressTo}
          onSelect={onAddressToSelect}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => (
            <div className="googlePlace" style={{ paddingTop: "10px" }}>
              <input
                {...getInputProps({
                  placeholder: " Search Address",
                  className: "",
                  id: "gSearchPlace",
                })}
              />
              <div className="autocomplete-dropdown-container">
                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? "suggestion-item--active"
                    : "suggestion-item";
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? {
                        backgroundColor: "#fafafa",
                        padding: "5px 15px 5px 15px",
                        cursor: "pointer",
                      }
                    : {
                        backgroundColor: "#ffffff",
                        padding: "5px 15px 5px 15px",
                        cursor: "pointer",
                      };
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </div>
      <div style={{ paddingLeft: "20px" }}>
        <Btn
          text={LABELS.LOAD}
          bgColor={COLORS.RELOAD_EXPORT}
          color={COLORS.RELOAD_EXPORT_TEXT}
          onClick={getScavengingDetails}
        />
      </div>
      <div style={{ boxShadow: "0px 0px 2px 0.5px grey", marginLeft: "20px" }}>
        <Btn
          text={LABELS.LEADS}
          bgColor={showLeadProfiles ? "white" : COLORS.DIM_GRAY}
          endIcon={<LeaderboardOutlinedIcon />}
          onClick={() => {
            setShowLeadProfiles(!showLeadProfiles);
          }}
          color={"black"}
        />
      </div>
      <div style={{ boxShadow: "0px 0px 2px 0.5px grey", marginLeft: "20px" }}>
        <Btn
          text={LABELS.CUSTOMERS}
          bgColor={showCustomer ? "white" : COLORS.DIM_GRAY}
          endIcon={<GroupOutlinedIcon />}
          onClick={() => {
            setShowCustomer(!showCustomer);
          }}
          color={"black"}
        />
      </div>
    </div>
  );
};
export default withSnackbar(MapSearchFilter);
